module.exports = __webpack_public_path__ + "img/affect-and-emotion.b40bbc35.svg";